export const PAGE_MAIN = '/';
